/* Menu do tema v4 (Luzzart): painéis do desktop, telas da gaveta do celular e ajustes do cabeçalho. */
(function () {
  'use strict';
  function hydrateImage(im) {
    var srcset = im.getAttribute('data-lz-srcset');
    var src = im.getAttribute('data-lz-src');
    if (srcset) { im.setAttribute('srcset', srcset); im.removeAttribute('data-lz-srcset'); }
    if (src) { im.setAttribute('src', src); im.removeAttribute('data-lz-src'); }
    im.loading = 'eager';
  }


  var docEl = document.documentElement;

  // Quem chega de anúncio (utm, gclid, fbclid...) não vê a barra "Use o app" nesta visita.
  try {
    if (/[?&](utm_[a-z]+|gclid|gbraid|wbraid|fbclid|ttclid|msclkid)=/i.test(location.search)) sessionStorage.setItem('luz_ads', '1');
    if (sessionStorage.getItem('luz_ads') === '1') docEl.classList.add('luz-ads');
  } catch (err) { /* sem sessionStorage: segue normal */ }

  function eager(scope) {
    var imgs = scope.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) hydrateImage(imgs[i]);
  }
  function setExpanded(scope, v) {
    var b = scope.querySelectorAll('[data-luzn-toggle]');
    for (var i = 0; i < b.length; i++) b[i].setAttribute('aria-expanded', v ? 'true' : 'false');
  }
  function focusables(scope) {
    return Array.prototype.filter.call(
      scope.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null && !el.closest('[inert]'); }
    );
  }

  // Desktop: abre com o mouse depois de uma pausa curta (evita abrir ao passar), pelo botão da seta
  // (teclado e toque) ou pelo 1º toque no nome em telas sem mouse. Fecha ao sair, com Esc, ao rolar
  // ou ao clicar fora. A barra se aperta sozinha quando não cabe na largura da tela.
  function initDesktop(root) {
    if (root.getAttribute('data-luzn-ready')) return;
    root.setAttribute('data-luzn-ready', '1');
    root.classList.add('js-ready');
    var items = root.querySelectorAll('[data-luzn-item].has-panel');
    var scrim = root.querySelector('[data-luzn-scrim]');
    // o cabeçalho fixo tem animação com transform, que prenderia o véu dentro dele; o véu vai para o body
    if (scrim && scrim.parentNode !== document.body) document.body.appendChild(scrim);
    var bar = root.querySelector('.luzn-bar');
    var side = root.querySelector('.luzn-side');
    var nav = root.closest('#main_navwr') || root;
    var hover = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)').matches : true;
    var openItem = null;
    var tOpen = 0;
    var tClose = 0;

    function overflows() {
      if (!bar || !root.clientWidth) return false;
      var cs = getComputedStyle(root);
      var avail = root.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var need = bar.scrollWidth + (side && getComputedStyle(side).display !== 'none' ? side.offsetWidth + 24 : 0);
      return need > avail + 1;
    }
    function fit() {
      root.classList.remove('is-tight', 'is-tighter');
      if (!overflows()) return;
      root.classList.add('is-tight');
      if (!overflows()) return;
      root.classList.add('is-tighter');
    }
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    var tFit = 0;
    window.addEventListener('resize', function () { clearTimeout(tFit); tFit = setTimeout(fit, 120); });

    function placeScrim() {
      if (!scrim) return;
      scrim.style.top = Math.max(0, Math.round(nav.getBoundingClientRect().bottom)) + 'px';
    }
    function open(item) {
      clearTimeout(tClose);
      if (openItem === item) return;
      if (openItem) close(openItem, true);
      openItem = item;
      eager(item);
      item.classList.add('is-open');
      setExpanded(item, true);
      placeScrim();
      if (scrim) scrim.classList.add('is-on');
    }
    function close(item, switching) {
      item.classList.remove('is-open');
      setExpanded(item, false);
      if (openItem === item) openItem = null;
      if (!switching && scrim) scrim.classList.remove('is-on');
    }

    Array.prototype.forEach.call(items, function (item) {
      item.addEventListener('mouseenter', function () {
        if (!hover) return;
        clearTimeout(tClose);
        clearTimeout(tOpen);
        tOpen = setTimeout(function () { open(item); }, openItem ? 40 : 120);
      });
      item.addEventListener('mouseleave', function () {
        if (!hover) return;
        clearTimeout(tOpen);
        tClose = setTimeout(function () { if (openItem === item) close(item); }, 200);
      });
      var toggles = item.querySelectorAll('[data-luzn-toggle]');
      Array.prototype.forEach.call(toggles, function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          clearTimeout(tOpen);
          if (openItem === item) close(item);
          else open(item);
        });
      });
      var top = item.querySelector('a.luzn-top');
      if (top) {
        top.addEventListener('click', function (e) {
          if (!hover && openItem !== item) {
            e.preventDefault();
            open(item);
          }
        });
      }
      item.addEventListener('focusout', function (e) {
        if (openItem === item && e.relatedTarget && !item.contains(e.relatedTarget)) close(item);
      });
    });

    if (scrim) scrim.addEventListener('click', function () { if (openItem) close(openItem); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !openItem) return;
      var item = openItem;
      var btn = item.querySelector('[data-luzn-toggle]');
      var hadFocus = item.contains(document.activeElement);
      close(item);
      if (btn && hadFocus) btn.focus();
    });
    document.addEventListener('click', function (e) {
      if (openItem && !openItem.contains(e.target)) close(openItem);
    });
    var lastY = window.pageYOffset;
    window.addEventListener('scroll', function () {
      if (!openItem) { lastY = window.pageYOffset; return; }
      if (Math.abs(window.pageYOffset - lastY) > 60) close(openItem);
    }, { passive: true });
    window.addEventListener('resize', function () { if (openItem) placeScrim(); });
  }

  // Celular: cada categoria com painel abre uma segunda tela; "Categorias" volta. Dentro de uma categoria,
  // a mensagem do WhatsApp já leva o nome dela. Ao fechar a gaveta, tudo volta ao começo e o foco volta ao
  // botão do menu; com a gaveta aberta, o Tab fica dentro dela. O botão voltar do aparelho, dentro de uma
  // categoria, volta para "Categorias" (a tela interna ganha uma entrada no histórico, que um link troca
  // pela página nova, para o voltar da página seguinte não precisar de dois toques).
  function initMobile(m) {
    if (m.getAttribute('data-luzm-ready')) return;
    m.setAttribute('data-luzm-ready', '1');
    var drawer = m.closest('.mob_nav_wr');
    var rootPanel = m.querySelector('[data-luzm-root]');
    var wa = m.querySelector('[data-luzm-wa]');
    var waDefault = wa ? wa.getAttribute('href') : '';
    var current = null;
    var hist = !!(window.history && window.history.pushState);
    var subPushed = false;
    var drawerPushed = false;
    var skipPop = 0;

    function waFor(name) {
      if (!wa) return;
      if (!name) { wa.setAttribute('href', waDefault); return; }
      var msg = 'Olá! Estou vendo ' + name + ' no site da Luzzart e quero ajuda para escolher.';
      wa.setAttribute('href', wa.getAttribute('data-luzm-wa') + encodeURIComponent(msg));
    }
    function activate(p, on) {
      if (on) {
        p.removeAttribute('inert');
        p.setAttribute('aria-hidden', 'false');
      } else {
        p.setAttribute('inert', '');
        p.setAttribute('aria-hidden', 'true');
      }
    }
    function show(id, from) {
      var p = m.querySelector('[data-luzm-panel="' + id + '"]');
      if (!p) return;
      eager(p);
      p.scrollTop = 0;
      activate(p, true);
      activate(rootPanel, false);
      m.classList.add('is-sub');
      p.classList.add('is-active');
      if (from) from.setAttribute('aria-expanded', 'true');
      current = { p: p, from: from };
      waFor(p.getAttribute('data-luzm-name'));
      var b = p.querySelector('[data-luzm-back]');
      if (b) setTimeout(function () { try { b.focus({ preventScroll: true }); } catch (err) { b.focus(); } }, 340);
      // com a gaveta aberta, a entrada dela no histórico já basta (uma só entrada: voltar fecha a categoria e depois a gaveta)
      if (hist && !subPushed && !drawerPushed) {
        try { window.history.pushState({ luzmSub: 1 }, ''); subPushed = true; } catch (err) { /* sem histórico: segue normal */ }
      }
    }
    function back(instant, fromPop, noHist) {
      if (!current) return;
      var c = current;
      current = null;
      if (subPushed) {
        subPushed = false;
        if (!fromPop && !noHist) { skipPop++; window.history.back(); }
      }
      m.classList.remove('is-sub');
      c.p.classList.remove('is-active');
      activate(c.p, false);
      activate(rootPanel, true);
      waFor('');
      if (c.from) {
        c.from.setAttribute('aria-expanded', 'false');
        if (!instant) setTimeout(function () { try { c.from.focus({ preventScroll: true }); } catch (err) { c.from.focus(); } }, 340);
      }
    }

    m.addEventListener('click', function (e) {
      var o = e.target.closest('[data-luzm-open]');
      if (o && m.contains(o)) {
        e.preventDefault();
        show(o.getAttribute('data-luzm-open'), o);
        return;
      }
      if (e.target.closest('[data-luzm-back]')) {
        e.preventDefault();
        back(false);
        return;
      }
      var a = e.target.closest('a[href]');
      if (a && (subPushed || drawerPushed) && a.target !== '_blank' && e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey) {
        var href = a.getAttribute('href') || '';
        if (href && href.charAt(0) !== '#' && href.indexOf('javascript:') !== 0 && a.protocol.indexOf('http') === 0) {
          e.preventDefault();
          subPushed = false;
          drawerPushed = false;
          window.location.replace(a.href);
        }
      }
    });
    // Esc: dentro de uma categoria volta para a lista; na lista, o tema fecha a gaveta
    // (o tema fecha a gaveta no keyup; o keyup do Esc que já voltou de tela é engolido)
    var escUsed = false;
    window.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !current) return;
      if (drawer && !drawer.classList.contains('active')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      escUsed = true;
      back(false);
    }, true);
    window.addEventListener('keyup', function (e) {
      if (e.key !== 'Escape' || !escUsed) return;
      escUsed = false;
      e.stopImmediatePropagation();
    }, true);
    if (!drawer) {
      window.addEventListener('popstate', function () {
        if (skipPop) { skipPop--; return; }
        if (current) back(false, true);
      });
      return;
    }
    var toggle = document.querySelector('header .navToggle');
    // voltar do aparelho: 1º fecha a categoria aberta; depois, fecha a gaveta (em vez de sair da página)
    window.addEventListener('popstate', function () {
      if (skipPop) { skipPop--; return; }
      if (current) {
        back(false, true);
        // a gaveta continua aberta: repõe a entrada dela, para o próximo voltar fechar a gaveta
        if (drawerPushed && drawer.classList.contains('active')) {
          try { window.history.pushState({ luzmDrawer: 1 }, ''); } catch (err) { drawerPushed = false; }
        }
        return;
      }
      if (drawerPushed && drawer.classList.contains('active')) {
        drawerPushed = false;
        var x = drawer.querySelector('.mobile-nav-close');
        if (x) x.click(); else if (toggle) toggle.click();
      }
    });
    var wasOpen = false;
    // tema 14/10: o conteúdo pode ser montado com a gaveta já aberta (carregado no toque do ☰); syncOpen roda também aí
    var syncOpen = function () {
        var isOpen = drawer.classList.contains('active');
        if (isOpen === wasOpen) return;
        wasOpen = isOpen;
        if (isOpen) {
          if (hist && !drawerPushed) {
            try { window.history.pushState({ luzmDrawer: 1 }, ''); drawerPushed = true; } catch (err) { /* sem histórico: segue normal */ }
          }
          eager(rootPanel);
          setTimeout(function () {
            var f = drawer.querySelector('.mobile-nav-close') || focusables(drawer)[0];
            if (f && !drawer.contains(document.activeElement)) { try { f.focus({ preventScroll: true }); } catch (err) { f.focus(); } }
          }, 320);
        } else {
          // fechou pelo X ou por fora: tira do histórico as entradas da gaveta e da categoria de uma vez
          var n = 0;
          if (current) { if (subPushed) n++; back(true, false, true); }
          if (drawerPushed) { n++; drawerPushed = false; }
          if (n) { skipPop++; window.history.go(-n); }
          rootPanel.scrollTop = 0;
          if (toggle && drawer.contains(document.activeElement)) toggle.focus();
        }
    };
    if (window.MutationObserver) new MutationObserver(syncOpen).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    if (drawer.classList.contains('active')) syncOpen();
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !drawer.classList.contains('active')) return;
      var f = focusables(drawer);
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (!drawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  // Busca do cabeçalho: ao abrir as sugestões, carrega as miniaturas na hora e tira a bolha de chat do caminho.
  function initSearch() {
    var boxes = document.querySelectorAll('.main-search, .searchDrawer');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.getAttribute('data-luz-search')) return;
      box.setAttribute('data-luz-search', '1');
      box.addEventListener('focusin', function () {
        docEl.classList.add('luz-search-open');
        eager(box);
        setTimeout(function () {
          var lazy = box.querySelectorAll('.s_res .lazyload');
          for (var i = 0; i < lazy.length; i++) {
            if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.unveil(lazy[i]);
          }
        }, 60);
      });
      box.addEventListener('focusout', function (e) {
        if (e.relatedTarget && box.contains(e.relatedTarget)) return;
        setTimeout(function () { if (!box.contains(document.activeElement)) docEl.classList.remove('luz-search-open'); }, 250);
      });
    });
  }

  // Faixa do topo que alterna mensagens: pausa com o mouse, o foco ou um toque (e volta ao sair).
  function initPromo() {
    var q = document.getElementById('Quotes-promotion-bar_top');
    if (!q || q.getAttribute('data-luz-promo')) return;
    q.setAttribute('data-luz-promo', '1');
    function ap() { return q.swiper && q.swiper.autoplay; }
    function stop() { if (ap()) q.swiper.autoplay.stop(); }
    function start() { if (ap()) q.swiper.autoplay.start(); }
    q.addEventListener('mouseenter', stop);
    q.addEventListener('mouseleave', start);
    q.addEventListener('focusin', stop);
    q.addEventListener('focusout', start);
    q.addEventListener('touchstart', function () {
      if (!ap()) return;
      if (q.swiper.autoplay.running) stop(); else start();
    }, { passive: true });
  }

  // Contador do carrinho: o "0" em destaque com o carrinho vazio some em todas as páginas; volta assim que entra um item.
  function initCartCount() {
    [].forEach.call(document.querySelectorAll('.cartCount'), function (el) {
      if (el.getAttribute('data-luz-count')) return;
      el.setAttribute('data-luz-count', '1');
      function upd() { el.classList.toggle('luz-zero', el.textContent.trim() === '0'); }
      upd();
      new MutationObserver(upd).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  // Celular: lupa no cabeçalho (a mesma da página de produto). Ela só aparece quando o cabeçalho fixo recolhe a busca;
  // o toque abre a gaveta de busca do tema (sem o tema carregado, o link leva à página de busca).
  var SEARCH_SVG = '<svg class="at-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" aria-hidden="true" focusable="false"><path d="M252.9,234.1l-53.4-53.4c-3.1-3.1-7.5-4.3-11.5-3.4c16.3-18.7,26.2-43.2,26.2-69.9c0-58.9-47.9-106.8-106.8-106.8 S0.6,48.5,0.6,107.3s47.9,106.8,106.8,106.8c27.1,0,51.9-10.2,70.8-26.9c-0.8,4,0.4,8.3,3.5,11.4L235,252c2.5,2.5,5.7,3.7,8.9,3.7 c3.2,0,6.5-1.2,8.9-3.7C257.8,247.1,257.8,239.1,252.9,234.1z M107.3,193.9c-47.7,0-86.6-38.8-86.6-86.6s38.8-86.6,86.6-86.6 s86.6,38.8,86.6,86.6S155.1,193.9,107.3,193.9z"/></svg>';
  function initSearchIcon() {
    var cols = document.querySelectorAll('.hdr_wrap .icons-col');
    for (var i = 0; i < cols.length; i++) {
      if (cols[i].querySelector('.searchIcn, .luz-search-ico')) continue;
      var a = document.createElement('a');
      a.className = 'hdicon searchIcn luz-search-ico';
      a.href = '/search';
      a.title = 'Buscar';
      a.setAttribute('aria-label', 'Buscar');
      a.innerHTML = SEARCH_SVG;
      cols[i].insertBefore(a, cols[i].firstChild);
    }
  }

  // Celular: com o cabeçalho fixo (depois de rolar e subir), a barra de busca vira a lupa e o cabeçalho fica com a altura
  // da linha do logo. A margem de baixo guarda a altura original no fluxo da página, para o conteúdo não pular.
  function initStickyCompact() {
    var w = document.querySelector('.hdr_wrap');
    if (!w || w.getAttribute('data-luz-compact') || !window.matchMedia) return;
    w.setAttribute('data-luz-compact', '1');
    var mq = window.matchMedia('(max-width: 989px)');
    function apply() {
      var want = mq.matches && w.classList.contains('sticky_hdr') && !docEl.classList.contains('luz-search-open');
      var on = w.classList.contains('luz-hdr-min');
      if (want === on) return;
      if (want) {
        var h = w.offsetHeight;
        w.classList.add('luz-hdr-min');
        var dh = h - w.offsetHeight;
        w.style.marginBottom = dh > 0 ? dh + 'px' : '';
      } else {
        w.classList.remove('luz-hdr-min');
        w.style.marginBottom = '';
      }
    }
    new MutationObserver(apply).observe(w, { attributes: true, attributeFilter: ['class'] });
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
    apply();
  }

  // Celular: com a gaveta da lupa aberta, o primeiro toque fora dela só fecha a gaveta (não abre o que está atrás).
  var searchOutsideBound = false;
  function initSearchOutside() {
    if (searchOutsideBound) return;
    searchOutsideBound = true;
    document.addEventListener('click', function (e) {
      if (!docEl.classList.contains('searchact')) return;
      if (e.target.closest && e.target.closest('.searchDrawer, .searchIcn, .luz-search-ico')) return;
      e.preventDefault();
      e.stopPropagation();
      docEl.classList.remove('searchact', 'showOverly', 'stopScroll', 'luz-search-open');
    }, true);
  }

  // Celular: a gaveta do menu chega depois (tema 14/10/2026). O cabeçalho manda só o contêiner [data-luzm-lazy]; o conteúdo
  // (o mesmo snippet luz-nav-mobile) vem de /?view=lz-mnav. Em tela de celular, o texto é buscado e lido quando a página
  // fica ociosa; a gaveta é montada no toque do ☰, antes de o tema abri-la (fase de captura). Se o ☰ for tocado antes da
  // pré-carga, a gaveta abre com "Carregando o menu…" e é montada quando o texto chega. Medido no teste A/B de 14/10.
  var mnav = { doc: null, req: null };
  function mnavBox() { return document.querySelector('[data-luzm-lazy]'); }
  function mnavFail() {
    var box = mnavBox();
    if (!box) return;
    box.removeAttribute('aria-busy');
    box.innerHTML = '<p class="luzm-lazy__msg">Não foi possível carregar o menu. <a href="/collections">Ver todas as categorias →</a></p>';
    // o contêiner é role="status" (anuncia a troca); o foco vai para o link de saída
    var a = box.querySelector('a');
    if (a) { try { a.focus({ preventScroll: true }); } catch (err) { a.focus(); } }
  }
  function mnavMount() {
    var box = mnavBox();
    if (!box) return true;
    if (!mnav.doc) return false;
    var c = mnav.doc.querySelector('[data-luzm-content]');
    mnav.doc = null;
    if (!c) return false;
    while (c.firstChild) box.parentNode.insertBefore(document.adoptNode(c.firstChild), box);
    box.parentNode.removeChild(box);
    var m = document.querySelector('[data-luzm]');
    if (!m) return false;
    // o conteúdo veio renderizado na página inicial: refaz a marca do item da página atual (o link.active do Liquid)
    var here = location.pathname.replace(/\/$/, '') || '/';
    [].forEach.call(m.querySelectorAll('a.luzm-row'), function (a) {
      var p = (a.pathname || '').replace(/\/$/, '') || '/';
      a.classList.toggle('is-current', p === here);
    });
    initMobile(m);
    return true;
  }
  function mnavFetch() {
    var box = mnavBox();
    if (!box || mnav.doc || mnav.req || !window.fetch || !window.DOMParser) return mnav.req;
    mnav.req = fetch(box.getAttribute('data-luzm-lazy'), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('status ' + r.status);
        return r.text();
      })
      .then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html');
        if (!d.querySelector('[data-luzm-content] [data-luzm]')) throw new Error('sem o menu');
        mnav.doc = d;
        mnav.req = null;
        var b = mnavBox();
        var drawer = b && b.closest('.mob_nav_wr');
        if (drawer && drawer.classList.contains('active')) mnavMount();
      })
      .catch(function () {
        mnav.req = null;
        var b = mnavBox();
        var drawer = b && b.closest('.mob_nav_wr');
        if (drawer && drawer.classList.contains('active')) mnavFail();
      });
    return mnav.req;
  }
  function initLazyMobile() {
    var box = mnavBox();
    if (!box || box.getAttribute('data-luzm-lazy-ready')) return;
    box.setAttribute('data-luzm-lazy-ready', '1');
    function idle() {
      if (window.matchMedia && !window.matchMedia('(max-width: 1024px)').matches) return;
      if (window.requestIdleCallback) window.requestIdleCallback(mnavFetch, { timeout: 4000 });
      else setTimeout(mnavFetch, 1500);
    }
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle);
  }
  var mnavBound = false;
  function bindLazyMobile() {
    if (mnavBound) return;
    mnavBound = true;
    function isToggle(e) { return e.target && e.target.closest && e.target.closest('.navToggle, .mbtMenu'); }
    // o dedo encosta no ☰: começa a buscar (uns 100 ms antes do clique)
    document.addEventListener('pointerdown', function (e) { if (isToggle(e) && mnavBox()) mnavFetch(); }, true);
    // o clique chega: o logo do topo da gaveta (adiado no HTML) carrega; o menu é montado antes do tema abrir a gaveta;
    // sem o texto ainda, busca e monta quando chegar
    document.addEventListener('click', function (e) {
      if (!isToggle(e)) return;
      var hd = document.querySelector('#MobileNavDrawer .mobile-nav-header');
      if (hd) eager(hd);
      if (!mnavBox()) return;
      if (!mnavMount()) mnavFetch();
    }, true);
  }

  function init() {
    initSearchOutside();
    initCartCount();
    initSearchIcon();
    initStickyCompact();
    initLazyMobile();
    bindLazyMobile();
    var d = document.querySelector('[data-luzn]');
    if (d) initDesktop(d);
    var m = document.querySelector('[data-luzm]');
    if (m) initMobile(m);
    initSearch();
    initPromo();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', initPromo);
  document.addEventListener('shopify:section:load', init);
})();
